import styled from 'styled-components';
export const SectionContainer = styled.section `
  padding: 60px 20px;
  background: #ffffff;
  width: 100%;
`;
export const Container = styled.div `
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 0 20px;
`;
export const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 4rem;
`;
export const SectionTitle = styled.h2 `
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  position: relative;
  display: inline-block;
  margin: 0;
  color: #1a1a1a;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #ffd700;
    border-radius: 2px;
  }
`;
export const Grid = styled.div `
  width: 100%;
  margin: 0 auto;
`;
export const Content = styled.div `
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  padding: 20px 0;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ffd700;
    border-radius: 4px;

    &:hover {
      background: #fdb927;
    }
  }
`;
export const Card = styled.div `
  background: #ffffff;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  border: 1px solid #f3f4f6;
  overflow: hidden;
  min-width: 320px;
  width: 320px;
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    width: 280px;
    min-width: 280px;
    padding: 1.5rem;
  }
`;
export const CardImage = styled.img `
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 1rem;
`;
export const CardContent = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const CardTitle = styled.h3 `
  font-size: 1rem;
  margin-bottom: 0.75rem;
  color: #1a1a1a;
  font-weight: 600;
  padding-right: 2.5rem;
`;
export const Tag = styled.span `
  display: inline-block;
  background: #ffd700;
  color: #1a1a1a;
  padding: 0.25rem 0.65rem;
  border-radius: 20px;
  font-size: 0.6875rem;
  font-weight: 600;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
`;
export const Metrics = styled.div `
  display: flex;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: auto;
  flex-wrap: wrap;
`;
export const MetricItem = styled.span `
  background: #f3f4f6;
  padding: 0.35rem 0.65rem;
  border-radius: 6px;
`;
export const Description = styled.p `
  font-size: 0.875rem;
  line-height: 1.5;
  color: #4b5563;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  flex: 1;
`;
export const CompanyLogo = styled.img `
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: 6px;
  background: #f8fafc;
  padding: 4px;
  z-index: 1;
`;
